import { render, staticRenderFns } from "./SafeSection.vue?vue&type=template&id=7e564f4e&scoped=true&"
import script from "./SafeSection.vue?vue&type=script&lang=js&"
export * from "./SafeSection.vue?vue&type=script&lang=js&"
import style0 from "./SafeSection.vue?vue&type=style&index=0&id=7e564f4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e564f4e",
  null
  
)

export default component.exports